module.exports = __webpack_public_path__ + "img/resource-tech-image-10.57152085.jpg";